import { render, staticRenderFns } from "./CostBreakdownSettings.vue?vue&type=template&id=6efa3194&scoped=true&"
import script from "./CostBreakdownSettings.vue?vue&type=script&lang=js&"
export * from "./CostBreakdownSettings.vue?vue&type=script&lang=js&"
import style0 from "./CostBreakdownSettings.vue?vue&type=style&index=0&id=6efa3194&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efa3194",
  null
  
)

export default component.exports